var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:'base-btn base-btn-' + _vm.variant,attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[(_vm.loading)?_c('BaseSpinner'):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }